import { gql } from "@apollo/client";

export const REFRESH_MESSAGES = gql`
  subscription refreshMessages($partnerId: Int!) {
    refreshMessages(partnerId: $partnerId) {
      partnerId
    }
  }
`;
